var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.391,23.946H25.214c-1.104,0-2,0.896-2,2v16.176c0,1.104,0.896,2,2,2h16.177c1.104,0,2-0.896,2-2V25.946 C43.391,24.841,42.496,23.946,41.391,23.946z M39.391,40.122H27.214V27.946h12.177V40.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.697,44.122c5.563,0,10.089-4.525,10.089-10.088c0-5.563-4.525-10.088-10.089-10.088 c-5.562,0-10.088,4.525-10.088,10.088C52.609,39.597,57.135,44.122,62.697,44.122z M62.697,27.946c3.357,0,6.089,2.731,6.089,6.088 s-2.731,6.088-6.089,6.088c-3.356,0-6.088-2.731-6.088-6.088S59.341,27.946,62.697,27.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.035,54.932c-0.357-0.619-1.018-1-1.732-1s-1.375,0.381-1.732,1l-8.088,14.01c-0.357,0.619-0.357,1.381,0,2 c0.357,0.619,1.018,1,1.732,1h16.177c0.714,0,1.375-0.381,1.732-1c0.357-0.619,0.357-1.381,0-2L35.035,54.932z M28.678,67.941 l4.625-8.01l4.625,8.01H28.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.229,54.405c-0.781-0.781-2.047-0.781-2.828,0l-5.704,5.704l-5.704-5.704c-0.781-0.781-2.047-0.781-2.828,0 s-0.781,2.047,0,2.828l5.704,5.704l-5.704,5.704c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586l5.704-5.704l5.704,5.704c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 c0.781-0.781,0.781-2.047,0-2.828l-5.704-5.704l5.704-5.704C72.011,56.452,72.011,55.187,71.229,54.405z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariation);
export default __webpack_public_path__ + "static/media/variation.cdac108bfbc3c3d66b1b683cdc9b13a4.svg";
export { ForwardRef as ReactComponent };